import { FlexTableExtension } from "../flex-table";
/** @typedef {import("../flex-table").FlexTableContext} FlexTableContext */

export class FrozenColumnsExtension extends FlexTableExtension {
    /**
     * Detach the fixed header extension from the context.
     * @param {FlexTableContext} flexTableContext The flex table context object
     */
    attach(flexTableContext) {
        if (this.isAttached) return
        super.attach(flexTableContext)

        // Left frozen columns require the horizontal container to be pushed right to compensate.
        const leftOffset = setFrozenColumnWidths(flexTableContext.table,
            flexTableContext.options.freezeLeft)
        setFrozenColumnHeights(flexTableContext.table,
            flexTableContext.options.freezeLeft)

        flexTableContext.horizontalContainer.style.marginLeft = leftOffset + "px";
        flexTableContext.horizontalContainer.style.width = "calc(100% - " + leftOffset + "px)";
        flexTableContext.horizontalContainer.style.overflowX = "auto";
    }

    /**
     * Detach the fixed header extension from the context.
     * @param {FlexTableContext} flexTableContext The flex table context object
     */
    detach(flexTableContext) {
        if (!this.isAttached) return

        unsetFrozenColumnHeights(flexTableContext.table,
            flexTableContext.options.freezeLeft)
        unsetFrozenColumnWidths(flexTableContext.table,
            flexTableContext.options.freezeLeft)
        super.detach(flexTableContext)
    }
}

function setFrozenColumnWidths(el, leftFrozenColumns) {
    let leftOffset = 0;

    for (let i = 1; i <= leftFrozenColumns; i++) {
        const colOffsetWidth = Array.from(el.querySelectorAll("td:nth-child(" + i + "), th:nth-child(" + i + ")"))
            .reduce(function (width, td) {
                return Math.max(width, td.offsetWidth);
            }, 0);
        const cells = el.querySelectorAll("td:nth-child(" + i + "), th:nth-child(" + i + ")");
        for (let j = 0; j < cells.length; j++) {
            const td = cells[j];
            td.style.width = colOffsetWidth + "px";
            td.style.left = leftOffset + "px";
            td.classList.add("freeze-column-cell")
        }
        leftOffset += colOffsetWidth;
    }
    return leftOffset;
}

function setFrozenColumnHeights(el, leftFrozenColumns) {
    // Could have multiple header rows, potentially.
    const rows = el.querySelectorAll("tr");
    const rowsLen = rows.length;
    for (let j = 0; j < rowsLen; j++) {
        const row = rows[j];
        // This part ends up running a lot and has a large performance cost.
        const rowStyle = window.getComputedStyle(row);
        const rowOffsetHeight = rowStyle.height;
        for (let i = 0; i < row.children.length; i++) {
            const cell = row.children[i];
            cell.style.height = rowOffsetHeight;
            // Process only frozen columns past this point.
            if (i >= leftFrozenColumns) continue;

            const cellStyle = window.getComputedStyle(cell)
            const verticalAlign = cellStyle.verticalAlign;

            cell.style.backgroundColor = rowStyle.backgroundColor;

            if (verticalAlign === "bottom") {
                cell.style.display = "flex";
                cell.style.flexDirection = "column";
                cell.style.justifyContent = "flex-end";
            } else if (verticalAlign === "middle") {
                cell.style.display = "flex";
                cell.style.flexDirection = "column";
                cell.style.justifyContent = "center";
            }
            // Done making calculations; set the frozen columns to their positions.
            cell.style.position = "absolute";
        }
    }
}

function unsetFrozenColumnWidths(el, leftFrozenColumns) {
    for (let i = 1; i <= leftFrozenColumns; i++) {
        const cells = el.querySelectorAll("td:nth-child(" + i + "), th:nth-child(" + i + ")");
        for (let j = 0; j < cells.length; j++) {
            const td = cells[j];
            td.style.width = "";
            td.style.borderTop = "";
            td.style.left = "";
            td.classList.remove("freeze-column-cell")
        }
    }
}

function unsetFrozenColumnHeights(el, leftFrozenColumns) {
    // Could have multiple header rows, potentially.
    const rows = el.querySelectorAll("tr");
    const rowsLen = rows.length;
    for (let j = 0; j < rowsLen; j++) {
        const row = rows[j];
        for (let i = 0; i < row.children.length; i++) {
            const cell = row.children[i];
            cell.style.height = "";
            // Process only frozen columns past this point.
            if (i >= leftFrozenColumns) continue;

            cell.style.padding = "";
            cell.style.marginTop = "";
            cell.style.position = "";
            cell.style.display = ""
            cell.style.flexDirection = "";
            cell.style.justifyContent = "";
        }
    }
}
